module.exports = __webpack_public_path__ + "src/assets/img/scroll-bg1.870f5504.png";